/**
 * Interface for Vigilant LPR search parameters.
 *
 * Backend:
 * - Path: fieldwatch-api/src/integrations/connectors/vigilant_ps/serializers.py
 * - Serializer: PlateSearchCreateSerializer
 */
export interface IFsLprVigilantParameters {
  // General
  plate: string;
  from_date?: string;
  to_date?: string;

  // Additional
  /**
   * vigilant only support 2 commas seperated coordinates that form a box
   * @url https://axon.quip.com/XNl4AMLfwayD/ALPR-Provider-Geo-Search-Limitations#temp:C:SJbda20bdaf0a7440019c84443de
   */
  in_bbox?: string;
}
